module.exports = __webpack_public_path__ + "static/media/knife_fire.a599107b.png";